import React, { PropsWithChildren } from 'react';

import styled from '@emotion/styled';

import { getStateLayerColor } from '@web/ui/theme/utils';

const TerminalTileContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.spacing('1000')};
  background-image: ${getStateLayerColor('greenFixed', 'semiTransparent')};
  border-radius: ${({ theme }) => theme.shape.corner[1500]};
`;

const Label = styled.p`
  color: ${({ theme }) => theme.color.greenFixed};
  font: ${({ theme }) => theme.typography.body.bold};
  font-size: ${({ theme }) => theme.typescale.size['0750']};

  text-shadow: 0px 0px 4px ${({ theme }) => theme.color.greenFixed};
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing('0500')};
`;

const Content = styled.div``;

interface ITerminalTileProps {
  label: string;
  className?: string;
  icon?: React.ReactNode;
}

export const TerminalTile = ({
  label,
  children,
  className,
  icon,
}: PropsWithChildren<ITerminalTileProps>) => {
  return (
    <TerminalTileContainer className={className}>
      <Label>
        {icon} {label}
      </Label>
      <Content>{children}</Content>
    </TerminalTileContainer>
  );
};
